var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployefilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "employe_icon",
    transform: "translate(22917 21987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-22917 -21987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    d: "M11,14.062V20h2V14.062A8,8,0,0,1,20,22H4a8,8,0,0,1,7-7.938ZM12,13a6,6,0,1,1,6-6A6,6,0,0,1,12,13Z",
    fill: "#7c0e6f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployefilledIcon);
export default __webpack_public_path__ + "static/media/employefilled_icon.5e7a84f6e09681c097df3bad4d9fd09c.svg";
export { ForwardRef as ReactComponent };